import React from 'react';
import styles from './OnlineSupport.m.sass';

import skypeIcon from '../../assets/images/social/skype.svg';
import discordIcon from '../../assets/images/social/discord.svg';
import envelopeIcon from '../../assets/images/social/envelope.svg';

export default function OnlineSupport() {
  return (
    <div className={styles.support}>
      <div className={styles.supportTop}>24/7 Online Support</div>
      <div className={styles.supportLinks}>
        <a href="skype:live:boosters4gamers?chat" className={styles.supportLink} target="_blank" rel="nofollow">
          <span className={styles.supportLinkIcon}>
            <img src={skypeIcon} alt=""/>
          </span>
          <span className={styles.supportLinkText}>Skype chat</span>
        </a>

        <a href="https://discord.gg/WVYyYuT" className={styles.supportLink} target="_blank" rel="nofollow">
          <span className={styles.supportLinkIcon}>
            <img src={discordIcon} alt=""/>
          </span>
          <span className={styles.supportLinkText}>Discord chat</span>
        </a>

        <a href="mailto:bosters4gamers@gmail.com" className={styles.supportLink} rel="nofollow">
          <span className={styles.supportLinkIcon}>
            <img src={envelopeIcon} alt=""/>
          </span>
          <span className={styles.supportLinkText}>Email us</span>
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/onlineSupport/OnlineSupport.js